import * as React from "react";
import { action } from "satcheljs/lib/legacy";
import { GlobalMessageViewState } from "../store/schema/GlobalMessageViewState";
import { MessageBarType } from "@fluentui/react";

/**
 * Action to set the message to display in the global message bar. Setting to blank string will clear the message.
 * @param {AppViewState} AppViewState
 * @param {string} message
 * @param {string} actionButtonTitle - title of optional action button (if you include a button title, you must include a callback function)
 * @param {Function} actionButtonCallback - callback for optional action button
 * @param {boolean} autoDismiss - set to true to have the message bar auto dismiss
 * @param {boolean} isMultiLine - set to true to prevent clipping of multi line message bar details
 * @param {number} autoDismissDelay - length of time in milliseconds to wait before auto dismissing the message bar
 * @param {number} autoDismissAnimationTimeout - duration of the animation in milliseconds to wait before auto dismissing the message bar
 * @param {boolean} useNewMessageBar - set to true to use the new Fluent UI v2 MessageBar component
 * @param {React.ReactElement} icon - custom icon for the message bar
 */
export default action("setGlobalMessages")(
    function setGlobalMessages(viewState: GlobalMessageViewState,
        messages: Array<React.ReactNode> = null,
        messageBarType: MessageBarType = MessageBarType.info,
        actionButtonTitle: string = null,
        actionButtonCallback: Function = null,
        autoDismiss: boolean = false,
        isMultiline: boolean = true,
        isCenterAligned: boolean = false,
        autoDismissDelay: number = null,
        autoDismissAnimationTimeout: number = null,
        useNewMessageBar: boolean = false,
        icon: React.ReactElement = null,
        secondaryMessage: React.ReactNode = null,
        actionButtonAriaLabel: string = null) {
            viewState.messages = messages;
            viewState.secondaryMessage = secondaryMessage;
            viewState.messageBarType = messageBarType;
            if (actionButtonTitle && actionButtonCallback) {
                // don't set the title or callback if either is missing
                viewState.actionButtonTitle = actionButtonTitle;
                viewState.actionButtonCallback = actionButtonCallback;
                viewState.actionButtonAriaLabel = actionButtonAriaLabel;
            } else {
                viewState.actionButtonTitle = viewState.actionButtonCallback = viewState.actionButtonAriaLabel = null;
            }
            viewState.autoDismiss = autoDismiss;
            viewState.isMultiline = isMultiline;
            viewState.isCenterAligned = isCenterAligned;
            viewState.autoDismissDelay = autoDismissDelay;
        viewState.autoDismissAnimationTimeout = autoDismissAnimationTimeout;
        viewState.useNewMessageBar = useNewMessageBar;
        viewState.icon = icon;
        viewState.messageVersion = (viewState.messageVersion ?? 0) + 1;
    });